<template>
    <div class="customer-default-speakers-form">
        <div v-if="canDelete" class="customer-default-speakers-form__delete">
            <button
                type="button"
                class="button users-repeater-item__delete"
                @click.prevent="$emit('delete', modelValue)"
            >
                <IconCross />
            </button>
        </div>
        <Grid gap-y="10">
            <Column>
                <FormField
                    :label="schema.language.label"
                    name="language"
                    :error="error"
                    :required="schema.language.required"
                >
                    <CustomSelect
                        v-model="localDefaultSpeaker.language"
                        emit-prop="id"
                        view-label="name"
                        :options="bookLanguages"
                        with-filter
                        width="100%"
                        :disabled="'id' in localDefaultSpeaker"
                    />
                </FormField>
            </Column>
            <Column>
                <FormField
                    :label="schema.speaker.label"
                    name="speaker"
                    :error="error"
                    :required="schema.speaker.required"
                >
                    <SpeakerSelect
                        v-model="localDefaultSpeaker.speaker"
                        :speakers="speakers"
                        :show-options="!!localDefaultSpeaker.language"
                        width="100%"
                        :empty-text="
                            localDefaultSpeaker.language
                                ? $t('editor.toolbar.noVoices')
                                : $t('upload.selectLanguage')
                        "
                    />
                </FormField>
            </Column>
        </Grid>
    </div>
</template>

<script>
import { fetchSpeakers } from '@speechki-frontend/core/editor/api/speakers';
import { FormField, CustomSelect } from '@speechki-frontend/shared/ui/forms';
import SpeakerSelect from '@speechki-frontend/shared/ui/SpeakerSelect';
import { Grid, Column } from '@speechki-frontend/shared/ui/Grid';
import { IconCross } from '@speechki-frontend/shared/ui/icons';

export default {
    name: 'CustomerDefaultSpeakersForm',
    components: {
        FormField,
        CustomSelect,
        SpeakerSelect,
        Grid,
        Column,
        IconCross,
    },
    props: {
        schema: {
            type: Object,
            required: true,
        },
        bookLanguages: {
            type: Array,
            default: () => [],
        },
        modelValue: {
            type: Object,
            default: () => ({}),
        },
        defaultSpeakers: {
            type: Array,
            default: () => [],
        },
        canDelete: {
            type: Boolean,
            default: true,
        },
        error: {
            type: Object,
            default: () => {},
        },
    },
    emits: ['update:modelValue', 'delete'],
    data() {
        return {
            speakers: [],
            localDefaultSpeaker: { ...this.modelValue },
        };
    },
    watch: {
        modelValue(val) {
            this.localDefaultSpeaker = { ...val };
        },
        localDefaultSpeaker: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', val);
            },
        },
        'localDefaultSpeaker.language': {
            immediate: true,
            handler(language) {
                this.fetchSpeakers(language);
            },
        },
    },
    methods: {
        async fetchSpeakers(language) {
            this.speakers = await fetchSpeakers({ book_language: language });
        },
    },
};
</script>

<style lang="scss" src="./CustomerDefaultSpeakersForm.scss"></style>
